export const SCHOOL_TYPE = [
  "Volksschule",
  "Gymnasiale Maturitätsschule",
  "Fachmittelschule",
  "Berufsfachschule",
  "Privatschule",
  "Sonderschule",
  "Andere",
];

export const SCHOOL_STEP = [
  "4. Klasse (Primar)",
  "5. Klasse (Primar)",
  "6. Klasse (Primar)",
  "7. Klasse (Sekundar I)",
  "8. Klasse (Sekundar I)",
  "9. Klasse (Sekundar I)",
  "1. Klasse (Sekundar II)",
  "2. Klasse (Sekundar II)",
  "3. Klasse (Sekundar II)",
  "4. Klasse (Sekundar II)",
];

export const SUBJECTS = [
  "Allgemeinbildung",
  "Anwendungen der Mathematik",
  "Begabtenförderung",
  "Berufliche Orientierung",
  "Bewegung und Sport",
  "Bildnerisches Gestalten",
  "Biologie",
  "Chemie",
  "Chinesisch",
  "Deutsch",
  "Deutsch als Zweitsprache",
  "Englisch",
  "Ethik, Religionen, Gemeinschaft",
  "Fächerübergreifend",
  "Französisch",
  "Geografie",
  "Geschichte",
  "Griechisch",
  "Hauswirtschaft",
  "Informatik",
  "Italienisch",
  "Klassenstunde, Klassenrat",
  "Latein",
  "Lebenskunde",
  "Mathematik",
  "Medien und Informatik",
  "Musik",
  "Natur und Technik",
  "Natur, Mensch, Gesellschaft",
  "Pädagogik/Psychologie",
  "Philosophie",
  "Physik",
  "Projektunterricht",
  "Räume, Zeiten, Gesellschaften",
  "Religion",
  "Religion, Ethik, Philosophie",
  "Religionen, Kulturen, Ethik",
  "Russisch",
  "Spanisch",
  "Sport",
  "Textiles und technisches Gestalten",
  "Wirtschaft und Recht",
  "Wirtschaft, Arbeit, Haushalt",
  "Anderes",
];
